{
  "error_offline_storage_not_available": "האחסון הבלתי מקוון אינו זמין. נא לוודא שהדפדפן שלך {0}תומך ב־API מסוג IndexedDB{1} וגם, אם הדפדפן שמשמש אותך מבוסס Google Chrome, שזאת אינה גלישה בסתר.",
  "error_invalid_subsection": "תת־סעיף שגוי:",
  "error_offline_storage": "שגיאת אחסון בלתי מקוון: {0}. אולי רענון יעזור. המצב הבלתי מקוון מושבת כרגע.",
  "error_share_native_abort": "לא ניתן לשתף פריט - או שאין יעד לשיתוף או שביטלת.",
  "error_configuration": "לא ניתן לטעון הגדרות.",
  "error_share_native": "לא ניתן לשתף פריט.",
  "article_actions": "פעולות",
  "close_entry": "סגירה",
  "info_url_copied": "הכתובת הועתקה ללוח הגזירים.",
  "error_sync": "לא ניתן לסנכרן את השינויים האחרונים מהשרת:",
  "error_refreshing_source": "לא ניתן לרענן מקורות:",
  "error_saving_color": "לא ניתן לשמור צבע חדש:",
  "error_loading_stats": "לא ניתן לטעון סטטיסטיקת ניווט:",
  "error_loading": "שגיאת טעינה:",
  "error_logout": "לא ניתן לצאת:",
  "error_star_item": "לא ניתן לסמן בכוכב/לבטל כוכב של פריט:",
  "error_mark_item": "לא ניתן לסמן/לבטל סימון של פריט:",
  "error_mark_items": "לא ניתן לסמן את כל הפריטים הגלויים:",
  "error_unknown_source": "מזהה המקור לא ידוע:",
  "error_unknown_tag": "תגית לא ידועה:",
  "error_load_tags": "לא ניתן לטעון תגיות:",
  "error_delete_source": "לא ניתן למחוק מקור:",
  "error_edit_source": "לא ניתן לשמור את שינויי המקור:",
  "error_add_source": "לא ניתן להוסיף מקור:",
  "error_session_expired": "תוקף ההפעלה פג",
  "app_reload": "רענון",
  "app_update": "selfoss התעדכן, נא לרענן",
  "sources_refreshed": "המקורות התרעננו",
  "reload_list": "לרענן רשימה",
  "streamerror": "לא נטענו פריטים, לרענן?",
  "error_unwritable_logs": "לא ניתן לכתוב יומנים.",
  "error_check_system_logs": "אירעה שגיאה, נא לעיין ביומני המערכת שלך.",
  "error_check_log_file": "אירעה שגיאה, נא לעיין בקובץ היומן „{0}”.",
  "error": "אירעה שגיאה",
  "no_title": "אין כותרת",
  "login_offline": "אחסון בלתי מקוון",
  "login_invalid_credentials": "שם משתמש/ססמה שגויים",
  "login_password": "ססמה",
  "login_username": "שם משתמש",
  "login": "כניסה",
  "more": "עוד",
  "no_entries": "לא נמצאו רשומות",
  "source_refresh": "לרענן את המקור הזה",
  "source_last_post": "הרשומה האחרונה שנראתה",
  "source_saved": "נשמר",
  "source_cancel": "ביטול",
  "source_save": "שמירה",
  "source_type": "סוג",
  "source_select": "נא לבחור מקור",
  "source_comma": "עם הפרדה בפסיקים",
  "source_pwd_placeholder": "לא השתנה",
  "source_tags": "תגיות",
  "source_autotitle_hint": "יש להשאיר ריק כדי לקבל את הכותרת",
  "source_title": "כותרת",
  "source_new": "מקור חדש שלא נשמר",
  "source_warn": "למחוק את המקור הזה?",
  "source_delete": "מחיקה",
  "source_filter": "מסנן",
  "source_edit": "עריכה",
  "source_export": "ייצוא מקורות",
  "source_opml": "או לייבא קובץ OPML",
  "source_add": "הוספת מקור",
  "sources": "מקורות",
  "loginbutton": "כניסה",
  "logoutbutton": "יציאה",
  "settingsbutton": "הגדרות",
  "refreshbutton": "לרענן מקורות",
  "searchremove": "הסתרת חיפוש",
  "searchbutton": "חיפוש",
  "search_label": "ביטוי לחיפוש",
  "share_copy_label": "העתקת קישור ללוח גזירים",
  "share_mail_label": "שיתוף בדוא״ל",
  "share_wordpress_label": "שיתוף בוורדפרס",
  "share_wallabag_label": "שמירה ב־Wallabag",
  "share_pocket_label": "שמירה ב־Pocket",
  "share_facebook_label": "שיתוף בפייסבוק",
  "share_twitter_label": "שיתוף בטוויטר",
  "share_diaspora_label": "שיתוף ב־Diaspora",
  "share_native_label": "שיתוף",
  "next": "הבא",
  "open_window": "פתיחה",
  "load_img": "הצגת תמונות",
  "unmark": "סימון שלא נקרא",
  "mark": "סימון שנקרא",
  "unstar": "ביטול כוכב",
  "star": "לסמן בכוכב",
  "days": "{0,plural,zero {היום},one {אתמול},two {שלשום},other {לפני # ימים}}",
  "seconds": "לפני {0,plural,one {שנייה},other {# שניות}}",
  "minutes": "לפני {0,plural,one {דקה},other {# דקות}}",
  "hours": "לפני {0,plural,one {שעה},two {שעתיים},other {# שעות}}",
  "timestamp": "‎{0,date} {0,time}",
  "alltags": "כל התגיות",
  "tags": "תגיות",
  "offline_navigation_unavailable": "החלפת תגיות ומקורות אינה זמינה כרגע במצב בלתי מקוון.",
  "offline_count": "פריטים זמינים מקומית",
  "online_count": "פריטים זמינים בשרת",
  "starred": "מסומן בכוכב",
  "unread": "לא נקרא",
  "newest": "החדש ביותר",
  "filter": "מסנן",
  "markread": "סימון שנקרא",
  "article_reading_time": "{0} דקות קריאה",
  "experimental": "ניסיוני",
  "source_warn_cancel_dirty": "להשליך את השינויים שלא נשמרו?",
  "sources_leaving_unsaved_prompt": "לצאת מההגדרות עם שינויים במקור שלא נשמרו?",
  "source_browse": "עיון",
  "source_menu": "פעולות נוספות",
  "tag_change_color_button_title": "החלפת צבע",
  "source_go_to_settings": "פתיחה בהגדרות",
  "sources_loading": "המקורות נטענים…",
  "no_sources": "לא הוגדרו מקורות.",
  "source_deleting": "המקור נמחק…",
  "source_params_loading": "המשתנים נטענים…",
  "source_saving": "השינויים למקור נשמרים…",
  "entries_loading": "הרשומות נטענות…",
  "login_in_progress": "מתבצע ניסיון כניסה…",
  "error_unauthorized": "נא {link_begin}להיכנס{link_end} כדי להמשיך.",
  "login_error_generic": "לא ניתן להיכנס: {errorMessage}",
  "share_mastodon_label": "שיתוף ב־Mastodon"
}
